<div class="container">
	<div class="page-wrapper">
		<div class="title-container">
			<h1 class="titolo-bertazzoni">Orders</h1>
		</div>
		<div class="mx-auto col-12 col-md-10 mt-5">
			<div class="d-lg-flex">
				<div class="d-flex justify-content-between">
					<h6 class="mr-4 mb-0">Order date:</h6>
					<div class="form-group mb-0 w-100">
						<select class="minimal w-100 rounded-0 border-black" name="anno" [(ngModel)]="filtri.anno">
							<option *ngFor="let anno of anni" [value]="anno">{{anno}}</option>
						</select>
					</div>
				</div>
				<div class="ml-lg-5 mt-3 mt-lg-0 d-none">
					<h6 class="mb-0 mr-3">Open orders:</h6>
					<div class="custom-control custom-checkbox">
						<input class="checkbox" type="checkbox" id="check-open" value="" name="filtroDaConfermare" [(ngModel)]="filtri.daConfermare" />
					</div>
				</div>
				<div class="ml-lg-5 mt-3 mt-lg-0 d-flex">
					<div class="row no-gutters">
						<div class="col">
							<input
								class="form-bertazzoni white border-right-0 rounded-0"
								type="SEARCH"
								placeholder="SEARCH"
								id=""
								name="parola"
								[(ngModel)]="filtri.parola" />
						</div>
						<div class="col-auto">
							<div class="border-left-0 rounded-0 rounded-right form-bertazzoni-search">
								<i class="icon-search font-16"></i>
							</div>
						</div>
					</div>
				</div>
				<div class="ml-lg-5 mt-3 mt-lg-0 d-flex">
					<button type="button" class="btn btn-bertazzoni black rounded-0 px-4" (click)="filtra()">SEARCH</button>
				</div>
			</div>

			<div class="orders-container">
				<div class="row w-100">
					<div class="col-md-6" *ngFor="let ordine of ordiniVisualizzati; let orderIndex = index">
						<div class="border border-black mt-4">
							<div class="bg-black text-white font-12 p-3">
								<div class="info-container">
									<div class="info-content">
										<p class="font-14">
											<span class="font-semibold">Order Number Bertazzoni:</span>
											{{trovaNSimag(ordine)}}
										</p>
										<p class="font-14">
											<span class="font-semibold">Order Number:</span>
											{{ordine.id}}
										</p>
										<p class="font-14">
											<span class="font-semibold">Articles total:</span>
											{{ordine.quantita}}
										</p>
										<p class="font-14">
											<span class="font-semibold">Purchase Order:</span>
											{{ordine.rifOrdineCliente}}
										</p>
										<p *ngIf="auth.isAdminOrBackoffice" class="font-14">
											<span class="font-semibold">User:</span>
											{{ordine.utente.username}}
										</p>
									</div>
									<div class="radio-button-container" (click)='onSelectedItem(ordine, "order")'>
										<input type="radio" name="order" class="custom-radio" id="order-{{orderIndex}}" [checked]="ordine.isSelected" />
										<label class="radio-btn-label" for="order-{{orderIndex}}"></label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="pt-5 px-lg-0">
		<div class="my-5">
			<div class="text-center mb-2">
				<h1 class="titolo-bertazzoni">Containers</h1>
			</div>
			<div class="mx-auto col-12 col-md-10 mt-5">
				<div class="orders-container">
					<div class="row">
						<div class="col-md-6" *ngFor="let container of mokeContainers; let containerIndex = index">
							<div class="border border-black mt-4">
								<div class="bg-black text-white font-12 p-3">
									<div class="info-container">
										<div class="info-content">
											<p class="font-14">
												<span class="font-semibold">Description:</span>
												{{container.descrizione}}
											</p>
											<p class="font-14">
												<span class="font-semibold">Height:</span>
												{{container.altezza}}
											</p>
											<p class="font-14">
												<span class="font-semibold">Length:</span>
												{{container.lunghezza}}
											</p>
											<p class="font-14">
												<span class="font-semibold">Depth:</span>
												{{container.profondita}}
											</p>
										</div>
										<div class="radio-button-container" (click)='onSelectedItem(container, "container")'>
											<input
												type="radio"
												name="container"
												class="custom-radio"
												id="container-{{containerIndex}}"
												[checked]="container.isSelected" />
											<label class="radio-btn-label" for="container-{{containerIndex}}"></label>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="continue-btn-container">
		<button
			type="button"
			class="btn btn-bertazzoni black rounded-0"
			[disabled]="!isOrderSelected || !isContainerSelected"
			(click)="continue()">
			CREATE CONTAINER
		</button>
	</div>
</div>
